import axios from 'axios'

export interface FearGreedData {
  value: number
  value_classification: string
  timestamp: string
  time_until_update: string
}

export const getFearGreedIndex = async (): Promise<FearGreedData> => {
  const { data } = await axios.get('https://api.alternative.me/fng/')
  
  return {
    value: parseInt(data.data[0].value),
    value_classification: data.data[0].value_classification,
    timestamp: new Date(parseInt(data.data[0].timestamp) * 1000).toISOString(),
    time_until_update: data.data[0].time_until_update,
  }
}
